module.exports = __webpack_public_path__ + "static/media/search-event.a49ec45a.png";